export const firstNavBarList = [
    {
      icon: (
        <lord-icon
          src="https://cdn.lordicon.com/hqymfzvj.json"
          trigger="hover"
          state="morph-book"
          target="#overview"
          
          style={{ width: "16px", height: "16px" }}
        ></lord-icon>
      ),
      title: "Overview",
      path: `/dashboard`,
      id: "overview",
    },
    {
      icon: (
        <lord-icon
          src="https://cdn.lordicon.com/ppyvfomi.json"
          trigger="hover"
          stroke="bold"
          state="morph-book"
          
          style={{ width: "16px", height: "16px" }}
        ></lord-icon>
      ),
      title: "Import Data",
      path: `/import-data`,
      id: "import-data",
    },


    {
      icon: (
        <lord-icon
          src="https://cdn.lordicon.com/rbbnmpcf.json"
          trigger="hover"
          target="#evidences"
          state="morph-home-2"
          
          style={{ width: "16px", height: "16px" }}
        ></lord-icon>
      ),
      title: "Evidences",
      path: `/evidences`,
      id: "evidences",
    },
    {
      icon: (
        <lord-icon
          src="https://cdn.lordicon.com/jfwzwlls.json"
          trigger="hover"
          target="#Report"
          state="morph-home-2"
          
          style={{ width: "16px", height: "16px" }}
        ></lord-icon>
      ),
      title: "Report",
      path: `/report`,
      id: "Report",
    },
  ];
  
  export const secondNavBarList = [
    {
      icon: (
        <lord-icon
          src="https://cdn.lordicon.com/jkgunhbs.json"
          trigger="hover"
          target="#frameworks"
          state="morph"
          
          style={{ width: "16px", height: "16px" }}
        ></lord-icon>
      ),
      title: "Browse Frameworks",
      path: `/browse-framework`,
      id: "frameworks",
    },
    {
      icon: (
        <lord-icon
          src="https://cdn.lordicon.com/zyzoecaw.json"
          trigger="hover"
          target="#frameworks"
          state="morph-book"
          
          style={{ width: "16px", height: "16px" }}
        ></lord-icon>
      ),
      title: "Policies",
      path: `/policies`,
      id: "frameworks",
    },
    {
      icon: (
        <lord-icon
          src="https://cdn.lordicon.com/prjooket.json"
          trigger="hover"
          target="#Library"
          state="morph-home-2"
          
          style={{ width: "16px", height: "16px" }}
        ></lord-icon>
      ),
      title: "Control Library",
      path: `/control-library`,
      id: "Library",
    },
    {
      icon: (
        <lord-icon
          src="https://cdn.lordicon.com/ercyvufy.json"
          trigger="hover"
          target="#LLM"
          state="morph-home-2"
          
          style={{ width: "16px", height: "16px" }}
        ></lord-icon>
      ),
      title: "Audyt AI",
      path: `/audyt-ai`,
      id: "audyt-ai",
    },
  ];
  export const thirdNavbarList = [
    {
      icon: (
        <lord-icon
          src="https://cdn.lordicon.com/kthelypq.json"
          trigger="hover"
          target="#usermanagement"
          state="morph-home-2"
          
          style={{ width: "16px", height: "16px" }}
        ></lord-icon>
      ),
      title: "User Management",
      path: `/user-management`,
      id: "usermanagement",
    },
    {
      icon: (
        <lord-icon
          src="https://cdn.lordicon.com/pflszboa.json"
          trigger="hover"
          target="#policiesbuilder"
          state="morph-home-2"
          
          style={{ width: "16px", height: "16px" }}
        ></lord-icon>
      ),
      title: "Polices Builder",
      path: `/policies-builder`,
      id: "policiesbuilder",
    },

    {
      icon: (
        <lord-icon
          src="https://cdn.lordicon.com/pqirzoux.json"
          trigger="hover"
          target="#data-Questionaire"
          state="morph-home-2"
          
          style={{ width: "16px", height: "16px" }}
        ></lord-icon>
      ),
      title: "Data Questionaire",
      path: `/data-Questionaire`,
      id: "data-Questionaire",
    },
    {
      icon: (
        <lord-icon
          src="https://cdn.lordicon.com/lecprnjb.json"
          trigger="hover"
          target="#settings"
          state="morph-home-2"
          
          style={{ width: "16px", height: "16px" }}
        ></lord-icon>
      ),
      title: "Settings",
      path: `/settings`,
      id: "settings",
    },
  ];
  